/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Pedal_Function_Mapping_TitleInputs */



/**
* | output |
* | --- |
* | "Function Mapping" |
*
* @param {Options_Pedal_Function_Mapping_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_pedal_function_mapping_title = /** @type {((inputs?: Options_Pedal_Function_Mapping_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Pedal_Function_Mapping_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Affectation des fonctions")
	if (locale === "de") return /** @type {LocalizedString} */ ("Funktionszuordnung")
	if (locale === "it") return /** @type {LocalizedString} */ ("Mappatura delle funzioni")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Функциональное сопоставление")
	if (locale === "es") return /** @type {LocalizedString} */ ("Mapeo de funciones")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("功能映射")
	if (locale === "ja") return /** @type {LocalizedString} */ ("関数マッピング")
	if (locale === "hi") return /** @type {LocalizedString} */ ("फ़ंक्शन मैपिंग")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Mapeamento de funções")
	return /** @type {LocalizedString} */ ("Function Mapping")
});